// NOTE: P&L과 margin, balance는 모두 USDT, 2자리로 통일한다.
// 또한 WS margin의 currency는 항상 USDT다.
// https://prextech.slack.com/archives/G011DKZ8AHL/p1672123304330989
export const UsdCurrency = 'USD';
export const UsdPrecision = 2;

export const UsdtCurrency = 'USDT';
export const UsdtPrecision = 2;

export const PusdtCurrency = 'PUSDT';
export const PusdtDisplayName = 'Premium Earn USDT'; // * 유저에게 절대 PUSDT로 보여지면 안됨.

export const NrsusdtpCurrency = 'NRSUSDTP';

export const Usd1Currency = 'USD1';
export const Usd1Precision = 2;

export const UsdeCurrency = 'USDE';
export const UsdePrecision = 2;

export const BitcoinCurrency = 'BTC';
export const EthereumCurrency = 'ETH';
export const BonusCurrency = 'AQXP';

export const UsdtCurrencyList = [PusdtCurrency, UsdtCurrency] as const;
export const UsdCurrencyList = [PusdtCurrency, UsdtCurrency, Usd1Currency, UsdeCurrency] as const;

/**
 * USDT 외에 마켓에서 전용 탭·캐러셀을 부여하는 quote currency 목록.
 * WLFI(USD1) sunset 으로 USD1 이 빠져 현재 비어 있다 — 서버 market layout 도
 * SUBSECTION_USD1 / data.usd1 을 더 이상 내려주지 않는다.
 *
 * 여기에 통화를 추가하면 마켓 discover 탭, 홈·마켓 캐러셀 카드, 주문 어트리뷰션 코드가
 * 자동으로 생성된다. dataRef 는 소문자 통화 코드 규약을 따른다(`getQuoteCurrencyDataRef`).
 */
export const QuoteCurrencyListExceptUsdt = [] as const;

/**
 * 현재 거래 가능한 quote currency. 포지션·주문·precision 의 도메인이다.
 * WLFI(USD1) sunset 으로 USD1 페어가 상장폐지되어 USDT 만 남았다.
 */
export const QuoteCurrencyList = [UsdtCurrency] as const;

export const FundingRatePrecision = 4;
export const AssetPrecision = 8;

export const SparkPointPrecision = 2;

export const maxDecimalPrecision = 18;
export const FeePrecision = 8;

export const CurrencyPrecisionMapper: Record<(typeof QuoteCurrencyList)[number], number> = {
  [UsdtCurrency]: UsdtPrecision,
} as const;

/**
 * quote currency 의 금액 표시·검증 precision.
 *
 * **매퍼를 직접 인덱싱하지 말고 이 함수를 쓸 것.** 매퍼의 키는 `QuoteCurrencyList` 에 묶여 있지만
 * 런타임에는 상장 데이터에서 온 임의의 quote currency 가 들어올 수 있다. 직접 인덱싱하면
 * 목록에 없는 통화에서 `undefined` 가 나오고, 그 값이 주문 금액 검증과 소수점 처리로 흘러간다
 * (타입상 `'USDT'` 로 좁혀져 있어 컴파일 에러로도 잡히지 않는다).
 *
 * 모르는 통화는 USDT 기준으로 폴백한다. quote currency 는 모두 USD 계열 스테이블코인이라
 * 자릿수가 같으므로 안전한 기본값이다.
 */
export const getQuoteCurrencyPrecision = (currency: string | undefined): number => {
  if (!currency) return UsdtPrecision;
  return (CurrencyPrecisionMapper as Record<string, number | undefined>)[currency] ?? UsdtPrecision;
};
